import { Component, ChangeDetectionStrategy } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({ standalone: false,
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent{
  public currentApplicationVersion = environment.appVersion;

  constructor() { }

  get logoSource(){
    return '../assets/images/logos/fa-logo-white.png';
  }

  get eggSource(){
    return '../assets/images/logos/pngegg.png';
  }
}
